import { Coord } from "../../types/Interface";


export default function getCenterOfTwoCoords(coordStart: Coord, coordEnd: Coord) {
  return {
    x: Number(((coordStart.x + coordEnd.x) / 2).toFixed(2)),
    y: Number(((coordStart.y + coordEnd.y) / 2).toFixed(2))
  }
}